import { AxiosError } from "axios";

import { BaseApiError } from "./BaseApiError";

export interface ForbiddenError extends AxiosError<string> {}

export class ForbiddenError extends BaseApiError {
  constructor(error: AxiosError<string>) {
    super(error);
  }
}
